import React from 'react'

import { builder, BuilderComponent } from '@builder.io/react'

builder.init('32eea804311a4d17817f2e534ded7af8')

const Landing = props => {
  return (
    <BuilderComponent
      model='content-sections'
      entry='b5530850c4e4467d98738094048e195a'
    />
  )

  /*
  return (
    <BuilderComponent
      model='page'
      entry='8b35105f327b44e383b614455e8f83e9'
    />
  )
  */
}

export default Landing
